
import { SwitcherFilter } from "@/interfaces";
import { defineComponent, PropType, ref } from "vue";

export default defineComponent({
  name: "Switcher",
  emits: ["change"],
  props: {
    active: {
      type: Object as PropType<SwitcherFilter>,
      default: null,
    },
    filters: {
      type: Array as PropType<SwitcherFilter[]>,
      default: [],
    },
  },
  setup(props, { emit }) {
    const onChange = (el: SwitcherFilter) => {
      emit("change", el);
    };

    return {
      onChange,
    };
  },
});
